import { Component, OnDestroy, OnInit } from '@angular/core';
import { RootState } from '@next/core-lib/app';
import { ExtendedNotificationComponent } from '@next/core-lib/components';
import { LocaleService, TranslatePipe } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { setMineralLegalNoticeVisibility } from '../../store/mineral.actions';
import { selectMineralLegalNoticeVisibility } from '../../store/mineral.selectors';

@Component({
  selector: 'app-mineral-legal-notice',
  templateUrl: './mineral-legal-notice.component.html',
  styleUrls: ['./mineral-legal-notice.component.scss'],
  imports: [ExtendedNotificationComponent, TranslatePipe],
})
export class MineralLegalNoticeComponent implements OnInit, OnDestroy {
  public showNotification = true;
  private subscription: Subscription;

  constructor(
    private readonly store: Store<RootState>,
    private readonly localeService: LocaleService,
  ) {}

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.subscription = this.store
      .select(selectMineralLegalNoticeVisibility)
      .subscribe((visible) => (this.showNotification = visible));
  }

  public getActionText() {
    return this.showNotification
      ? this.localeService.translate('mineral.mineral-legal-notice.action-text-close')
      : this.localeService.translate('mineral.mineral-legal-notice.action-text-open');
  }

  public toggleNotification() {
    this.store.dispatch(setMineralLegalNoticeVisibility({ visible: !this.showNotification }));
  }
}
